var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroupsSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M30.5 57.1665V23.8332M30.5 57.1665C30.5 60.8484 27.5152 63.8332 23.8333 63.8332H17.1667C13.4848 63.8332 10.5 60.8484 10.5 57.1665V23.8332C10.5 20.1513 13.4848 17.1665 17.1667 17.1665H23.8333C27.5152 17.1665 30.5 20.1513 30.5 23.8332M30.5 57.1665C30.5 60.8484 33.4848 63.8332 37.1667 63.8332H43.8333C47.5152 63.8332 50.5 60.8484 50.5 57.1665M30.5 23.8332C30.5 20.1513 33.4848 17.1665 37.1667 17.1665H43.8333C47.5152 17.1665 50.5 20.1513 50.5 23.8332M50.5 57.1665V23.8332M50.5 57.1665C50.5 60.8484 53.4848 63.8332 57.1667 63.8332H63.8333C67.5152 63.8332 70.5 60.8484 70.5 57.1665V23.8332C70.5 20.1513 67.5152 17.1665 63.8333 17.1665H57.1667C53.4848 17.1665 50.5 20.1513 50.5 23.8332",
    stroke: "#345658",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsSale);
export default __webpack_public_path__ + "static/media/GroupsSale.556c4e34336f59526e92db79e9207bdd.svg";
export { ForwardRef as ReactComponent };